<template>    
    <v-card color="#fff" light>
        <v-img 
            :src="imgSource"
            aspect-ratio="2"
                                  
        ></v-img>   
        <v-card-title>            
            <h2 class="display-5">{{ item.name }}</h2> </br>                
        </v-card-title>                                        
        <v-container grid-list-xs fill-height class="py-0 my-0">
            <v-layout row wrap fill-height>
                <v-flex xs12>
                        <v-rating
                            v-model="rating"
                            background-color="light-grey"
                            color="yellow accent-4"
                            dense
                            half-increments
                            empty-icon="$vuetify.icons.ratingFull"
                            hover
                            size="18"
                        ></v-rating>
                    </v-flex>
                <v-flex xs4>                    
                      <v-layout column>
                        <v-flex>
                            
                           
                        </v-flex>
                        <v-flex>
                                                                                                                                 
                        </v-flex>
                    </v-layout>         
                </v-flex>
                <v-flex d-flex xs2></v-flex>
                <v-flex d-flex xs6>
                    
                </v-flex>
            </v-layout>
        </v-container>

                        
        <v-card-actions class="lime darken-4 pt-0">
            
            <listactionbar v-on:actiontriggered="onAction" :item="item" :tileactions="tileactions"></listactionbar>
            
        </v-card-actions>  
                    
        
    </v-card>
</template>
<script>
    import listactionbar from './ListActionbar.vue'
    import { mapGetters } from 'vuex';    
    export default {   
    
    props: [
        'item',
        'tileactions',
        'paths'
    ],
    components: {
        listactionbar:listactionbar
    },
    data() {
        return {  
           rating:1
                    
        }
    },
    computed: {
        defaultlogo: function(){
            return this.paths.recipepath + this.item.id + '/logos/' + process.env.VUE_APP_DEFAULT_LOGO
        },
        imgSource: function() {
            return this.item.logos[0] ? this.paths.storagepath + this.item.logos[0].serverpath : this.defaultlogo
        }
    },
    methods: {
        onAction(action){
            
            if(action.link!=""){
                this.$router.push({name: action.link, params: {id: this.item.id}})
            } else {
                var r = confirm("Der Datensatz wird gelöscht")
                if (r == true) {                
                    this.$store.dispatch('entities/deleteById',this.item.id)
                            .then(response=>{
                                this.setMessage('200','Erfolg. Das Rezept/die Zutat wurde gelöscht')
                            }).catch(error=>{                                
                                this.setMessage(error.response.status,error.response.status)
                            })
                }else{                    
                }
            }
        }
    },
    
    
    
}
</script>
